import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Insurance } from '@/core/domain/reservation/models/insurance.model';
import { InsuranceRepository } from '@/core/domain/reservation/repositories/insurance.repository';

@Injectable({
    providedIn: 'root',
})
export class InsuranceImplRepository extends InsuranceRepository {
    private insuranceSubject: BehaviorSubject<Insurance> =
        new BehaviorSubject<Insurance>({ isInsurance: false });

    override toggleInsurance(): Observable<Insurance> {
        const currentInsurance = this.insuranceSubject.value;
        const updatedInsurance = { isInsurance: !currentInsurance.isInsurance };
        this.insuranceSubject.next(updatedInsurance);
        return this.insuranceSubject.asObservable();
    }

    override getInsurance(): Observable<Insurance> {
        return this.insuranceSubject.asObservable();
    }
}
